import { useContext } from 'react';
import { CustomerContext } from './Customer';

export default () => useContext(CustomerContext);
